// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sj-9";
export var arrowButtonContainer = "_sj-5";
export var arrowButtonIcon = "_sj-6";
export var carouselArrowButton = "_sj-2";
export var carouselElementContainer = "_sj-1";
export var currentSlide = "_sj-8";
export var left = "_sj-3";
export var otherSlide = "_sj-a";
export var productCarouselContainer = "_sj-0";
export var right = "_sj-4";
export var sliderOverflow = "_sj-7";